import {ReactComponent as FolderIcon} from "../../../assets/images/folder.svg";
import {ReactComponent as DocumentsIcon} from "../../../assets/images/documents.svg";
import {ReactComponent as ExcelIcon} from "../../../assets/images/excel.svg";
import {ReactComponent as WordIcon} from "../../../assets/images/word.svg";
import {ReactComponent as PowerpointIcon} from "../../../assets/images/powerpoint.svg";
import {ReactComponent as PdfIcon} from "../../../assets/images/pdf.svg";
import {ReactComponent as AutoCad} from "../../../assets/images/auto-cad.svg";
import {ReactComponent as ImageIcon} from "../../../assets/images/image.svg";
import hwpIcon from "../../../assets/images/hwp.png";
import {ReactNode} from "react";

const HwpIcon = () => {
  return <img src={hwpIcon} alt="hwpIcon" width="36px" height="36px" />;
};

export interface KPFile {
  uid: number;
  guid: string;
  companyUID: number;
  folderUID: number; // 파일이 속한 폴더의 UID
  name: string;
  extension: string;
  type: number;

  entryDate: Date | string;
  modifyDate: Date | string;
}

export const initializeFile = (): KPFile => {
  return {
    uid: 0,
    guid: "00000000-0000-0000-0000-000000000000",
    companyUID: 0,
    folderUID: 0, // 파일이 속한 폴더의 UID
    name: "",
    extension: "",
    type: 0,

    entryDate: new Date(),
    modifyDate: new Date(),
  };
};

export const TypeSelectIcon = (type: number): ReactNode => {
  switch (type) {
    case 0:
      return <DocumentsIcon />;
    case 1:
      return <ExcelIcon width="36px" height="36px" />;
    case 2:
      return <WordIcon width="36px" height="36px" />;
    case 3:
      return <PowerpointIcon width="36px" height="36px" />;
    case 4:
      return <PdfIcon width="36px" height="36px" />;
    case 5:
      return <AutoCad />;
    case 6:
      return <ImageIcon />;
    case 7:
      return <HwpIcon />;
  }
};
